import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { OpsSelectComponent } from '../ops-select/ops-select.component';
import { OpsOrganisationSettingsComponent } from './ops-organisation-settings.component';
import { OpsFileUploadButtonComponent } from '../ops-file-upload-button/ops-file-upload-button.component';
import { NgxsModule } from '@ngxs/store';
import { SettingsEditState } from '@ops/services';
import { OpsAddAdditionalMediaChannelComponent } from '../ops-add-additional-media-channel/ops-add-additional-media-channel.component';
import { OpsInputPreviewComponent } from '../ops-input-preview/ops-input-preview.component';
import { OpsInputWithListItemsComponent } from '../ops-input-with-list-items/ops-input-with-list-items.component';
import { OpsCalendarComponent } from '../ops-calendar/ops-calendar.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    OpsInputComponent,
    OpsInputPreviewComponent,
    OpsInputWithListItemsComponent,
    OpsCalendarComponent,
    OpsSelectComponent,
    OpsFileUploadButtonComponent,
    OpsAddAdditionalMediaChannelComponent,
    NgxsModule.forRoot([SettingsEditState]),
  ],
  declarations: [OpsOrganisationSettingsComponent],
  exports: [OpsOrganisationSettingsComponent],
})
export class OpsOrganisationSettingsModule {}
